import './TimeAggregationFilter.css';
import { t } from 'i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import { fetchingReportsData, updateFilter } from '../../../reducer/actions';

const TimeAggregationFilter = ({
  value, fetchData, dispatch, aggregateByDays = false
}) => (
  <div className="TimeAggregationFilter">
    <select disabled={`${fetchData.fetches > 0 ? 'disabled' : ''}`}
      className={`${fetchData.fetches > 0 ? 'disableTimeFilter' : ''}`}
      defaultValue={value}
      onChange={({ target }) => {
        dispatch(updateFilter({
          aggregate_by: target.value,
        }));
        dispatch(fetchingReportsData(true));
      }}
    >
      {aggregateByDays && <option value="day">{t('days')}</option>}
      <option value="week">{t('weeks')}</option>
      <option value="month">{t('months')}</option>
      <option value="year">{t('years')}</option>
    </select>
    <label>
      {t('display')}
      :
      {' '}
    </label>
  </div>
);

export default withRouter(connect(s => s)(TimeAggregationFilter));
